// State argument is not application state, only the state this reducer is responsible for
function templateByRedux(state = null, action) {
  switch (action.type) {
    case "SET_TEMPLATE":
      return action.value;
    default:
      return state;
  }
}
export default templateByRedux;
